require("@rails/ujs").start()
require("@rails/activestorage").start()
const $ = global.$ = global.jQuery = require("jquery")

import '@claviska/jquery-minicolors'
import '@claviska/jquery-minicolors/jquery.minicolors.css'

import 'bootstrap'
import '../scss/backend.scss'

const images = require.context('../images', true)

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
})

import Vue from 'vue'
import MappedColumnMapper from '../components/MappedColumnMapper.vue'

const MappedColumnMapperComponentClass = Vue.extend(MappedColumnMapper)



$(function(){
    $('[data-vue-component="mapped-column-mapper"]').each(function(){
        let propsData = $(this).data('vue-props')
        let mappedColumnMapper = new MappedColumnMapperComponentClass({ propsData: propsData })
        mappedColumnMapper.$mount()
        this.appendChild(mappedColumnMapper.$el)
    })
})

// Inject file name for bootstrap_form file_fields
$(document).on('change', '.custom-file-input', function(){
    let $label = $(this).next('.custom-file-label')

    let originalLabel = $label.data('original-label')
    if( originalLabel === undefined ){
        originalLabel = $label.html()
        $label.data('original-label', originalLabel)
    }

    console.log('originalLabel', originalLabel)

    let file = this.files[0]
    if( file ){
        $label.html(file.name)
    } else {
        $label.html(originalLabel)
    }
})

window.addEventListener("load", () => {

    // Hides elements selected by the selector 'hides', when the value of the input evaluates to a truthy value
    const hides_handler = (element) => {
        const { hides } = element.dataset;
        document.querySelectorAll(hides).forEach(element => {
            element.style.visibility = (element.value) ? 'collapse' : 'visible'
        })
    }
    document.querySelectorAll(
      "input[data-hides],select[data-hides]"
    ).forEach((element) => {
        element.addEventListener("change", (event) => {
            hides_handler(element)
        });
        hides_handler(element)
    });

    // Replaces the element and its children with a button. Pressing the button opens a modal with the element as its body.
    const createContentModal = (element) => {
        const {title = "data-title appears here", buttonText = "data-button-text appears here", modalId = `modal_${element.id}`, buttonClass = "btn btn-primary" } = element.dataset
        const modalTemplate = document.createElement('template')
        modalTemplate.innerHTML = `<div class="modal fade" id="${modalId}" tabindex="-1" role="dialog" aria-labelledby="modal_header_${modalId}" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modal_header_${modalId}">${title}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      </div>
    </div>
  </div>
</div>`

        element.insertAdjacentHTML('beforebegin', `<a href="#" data-toggle="modal" data-target="#${modalId}" class="${buttonClass}">${buttonText}</a>`)
        let modal = document.body.appendChild(modalTemplate.content.firstElementChild.cloneNode(true))
        modal.querySelector("div.modal-body").appendChild(element)
    }
    document.querySelectorAll("[data-as-a='modal']").forEach(createContentModal)
});